<template>
  <img
    :src="value ? '/icons/ok.svg' : '/icons/cancel.svg'"
    :alt="value ? '✓' : '!'"
    @click="emit"
  />
</template>

<script>
export default {
  props: {
    value: Boolean,
    readonly: Boolean
  },
  methods: {
    emit() {
      if (!this.readonly) this.$emit("input", !this.value);
    }
  }
};
</script>

